import { Hours, Is24Hour, TimePeriod, TIME_PERIODS } from '../consts';

export const padNumber = (num?: string | number) => {
  if (num === undefined || num === '') {
    return '';
  }

  const strNumber = num.toString();

  const currentLength = strNumber.length;

  return currentLength < 2
    ? `${'0'.repeat(2 - currentLength)}${strNumber}`
    : strNumber;
};

export const toTwelveHour = (hours: number) => {
  if (hours === 0) {
    return 12;
  }

  return hours > 12 ? hours - 12 : hours;
};

export const getTimePeriod = (
  time?: Hours & Is24Hour,
): TimePeriod | undefined => {
  if (!time || time.is24Hour || time.hours === undefined) {
    return undefined;
  }

  return time.hours > 11 ? 'PM' : 'AM';
};

export const flipPeriod = (timePeriod?: TimePeriod) =>
  timePeriod === TIME_PERIODS.PM ? TIME_PERIODS.AM : TIME_PERIODS.PM;

export const toDisplayHours = (time?: Hours & Is24Hour): number | undefined => {
  if (time === undefined || time.hours === undefined) {
    return undefined;
  }

  return time.is24Hour ? time.hours : toTwelveHour(time.hours);
};

const addWithinRange = ({
  initial,
  toAdd,
  min = 0,
  max,
}: {
  initial: number;
  toAdd: number;
  min?: number;
  max: number;
}) => {
  const range = max - min + 1;
  let toReturn = initial + toAdd;

  if (toReturn > max) {
    toReturn = toReturn - range;
  }

  if (toReturn < min) {
    toReturn = toReturn + range;
  }

  return toReturn;
};

export const addHours = ({
  hours = 0,
  toAdd,
}: {
  hours?: number;
  toAdd: number;
}) => {
  const newHours = addWithinRange({ initial: hours, toAdd, max: 23 });
  return {
    hours: newHours,
    timePeriod: newHours > 11 ? TIME_PERIODS.PM : TIME_PERIODS.AM,
  };
};

export const addMinutes = ({
  hours = 0,
  minutes = 0,
  toAdd,
}: {
  hours?: number;
  minutes?: number;
  toAdd: number;
}) => {
  const nextMinutes = minutes + toAdd;
  const newMinutes = addWithinRange({ initial: minutes, toAdd, max: 59 });
  const incrementHour = nextMinutes > 59;
  const decrementHour = nextMinutes < 0;
  return {
    minutes: newMinutes,
    ...(incrementHour || decrementHour
      ? addHours({
          hours,
          toAdd: (incrementHour && 1) || (decrementHour && -1) || 0,
        })
      : {}),
  };
};

export const addTimePeriod = ({
  hours = 0,
  timePeriod,
}: {
  hours?: number;
  timePeriod?: TimePeriod;
}) => {
  const newTimePeriod = flipPeriod(timePeriod);
  return {
    timePeriod: newTimePeriod,
    hours: newTimePeriod === TIME_PERIODS.AM ? hours - 12 : hours + 12,
  };
};

export const isPropControlled = (prop: unknown) => {
  return prop !== undefined;
};
